import { render, staticRenderFns } from "./r-boat-order-dropdown.vue?vue&type=template&id=3b90eedb"
import script from "./r-boat-order-dropdown.vue?vue&type=script&lang=js"
export * from "./r-boat-order-dropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b90eedb')) {
      api.createRecord('3b90eedb', component.options)
    } else {
      api.reload('3b90eedb', component.options)
    }
    module.hot.accept("./r-boat-order-dropdown.vue?vue&type=template&id=3b90eedb", function () {
      api.rerender('3b90eedb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/boats/r-boat-order-dropdown.vue"
export default component.exports